<script>
    import { onMount, onDestroy } from 'svelte';
    import { Link } from "svelte-routing";
    import { apiRequest } from "../lib/Request.svelte";
    import {loadPaySelection} from "../lib/OrdersHelper";
    import {_} from '../lib/i18n';
    import StripePaymentForm from "../components/StripePaymentForm.svelte";

    export let params = {};
    export let locale = 'ru-RU';
    let path = '';
    let sum;
    $: path = (params && params.path) ? params.path : '';
    export let orderId;

    let errorText = '';
    export let paymentAgent;

    export let stripeKey;

    let orderSum;

    onMount(() => {
        //window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: '',
                    pageTitleTag: '',
                    pageId: 'order',
                });
            }
        } catch (err) {
            console.error(err);
        }

        const orderResponse = apiRequest('GET', `/payments/invoice-token?id=${orderId}`, {}, {})
            .then((response) => {
                if (response.status === 'ok') {
                    orderSum = response.sum;
                    if (response.agent === 'payselection') {
                        const timer = setInterval(() => {
                            console.log('tick');
                            if (window.pw) {
                                sum = response.sum
                                loadPaySelection(response, orderId)
                                clearInterval(timer);
                                console.log('cleared');
                            }
                        }, 250);
                        return;
                    }

                    const timer = setInterval(() => {
                        if (window.YooMoneyCheckoutWidget) {
                            initYKWidget(response.token)
                            clearInterval(timer);
                            console.log('cleared');
                        }
                    }, 250);
                } else {
                    errorText = response.message;
                }
            })
    });

    onDestroy(() => {
        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: '',
                    pageTitleTag: '',
                    pageId: null,
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    function initYKWidget(token) {
        console.log('Initiating yooKassa widget');
        // Инициализация виджета. Все параметры обязательные.
        const checkout = new window.YooMoneyCheckoutWidget({
            confirmation_token: token, //Токен, который перед проведением оплаты нужно получить от ЮKassa
            return_url: `https://${window.location.hostname}${path}/dashboard/order-success?id=${orderId}`, //Ссылка на страницу завершения оплаты
            customization: {
                //Выбор способа оплаты для отображения
                payment_methods: ['bank_card']
            },
            error_callback: function (error) {
                console.log(error);
            }
        });

        try {
            // Отображение платежной формы в контейнере
            checkout.render('payment-form')
                // После отображения платежной формы метод render возвращает Promise (можно не использовать).
                .then(() => {
                    // Код, который нужно выполнить после отображения платежной формы.
                });
        } catch (err) {
            console.error(err);
        }
    }


</script>

<div class="" >
    {#if paymentAgent === 'stripe'}
        <StripePaymentForm
                {locale}
                backUrl="/instashpion/dashboard"
                stripePublishableKey={window.settings.stripePublishableKey}
                savePaymentMethodUrl={window.settings.savePaymentMethodUrl}
                createPaymentUrl={window.settings.createPaymentUrl}
                checkInvoiceStatusUrl={window.settings.checkInvoiceStatusUrl}
                onPaymentSuccessRedirectUrl={window.settings.onPaymentSuccessRedirectUrl}
                userAgreementUrl={'/terms'}
                showDataJamPaymentExplanation={window.settings.showDataJamPaymentExplanation}
                currencySign={window.settings.currencySign}
                currencyCode={window.settings.currencyCode}
                amount={orderSum}
                {path}
                {orderId}
        />
    {:else}
        <div id="payment-form" style={{margin: '4em auto'}} />
        {#if window.shared.testGroupPaySelection === 'b'}
            <button class="button button_ghost plan-card__btn" on:click={loadPaySelection}>
                {$_('order.payBtnLabel')}
            </button>
        {/if}
    {/if}
</div>

<style>

</style>